export default "__VITE_ASSET__BcQA38Ca__"